export function Spinner({ label = '불러오는 중...' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-charcoal-500" role="status">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-cream-300 border-t-primary-500" aria-hidden="true" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
